export default "__VITE_ASSET__QhsNAjnl__"